import React, { useState } from 'react';
import { connect } from 'react-redux';
import Asterisk from '~/components/shared/Asterisk/Asterisk';
import SpellCheckerInput from '~/components/shared/SpellCheckerInput/SpellCheckerInput';
import { AD_DETAILS_API_IDS } from '~/helpers/adDetails';
import { extractAttributesFromTitle } from '~/helpers/adDetails/titleAttributesParser';
import { useGetCategoryAttributes } from '~/hooks/useGetCategoryAttributes';
import { AUTO_FILL_ATTRIBUTES, HANDLE_CHANGE } from '~/store/reducers/products';

function Title({ component, titleValue, validation_rules, dispatch, categories, currentAttributes }) {
  const [title, setTitle] = useState(titleValue);
  const { key, helptext } = component;

  const required = validation_rules[key].required;
  const max_length = validation_rules[key].max_length;

  // Récupérer les attributs de la catégorie depuis le cache React Query
  const currentCategoryId = categories && categories.length > 0 ? categories[categories.length - 1].id : null;
  const { data: categoryAttributes } = useGetCategoryAttributes(currentCategoryId);

  const handleChange = (value) => {
    let formattedValue = value;

    // Capitalize first letter of the title
    formattedValue = formattedValue.charAt(0).toUpperCase() + formattedValue.slice(1);
    setTitle(formattedValue);
  };

  const autoFillAttributes = (titleValue) => {
    // Ne rien faire si pas de catégorie ou pas d'attributs disponibles
    if (!currentCategoryId || !categoryAttributes || categoryAttributes.length === 0) {
      return;
    }

    const extractedAttributes = extractAttributesFromTitle(titleValue, categoryAttributes, currentAttributes);

    // Dispatcher seulement s'il y a des attributs à remplir
    if (Object.keys(extractedAttributes).length > 0) {
      dispatch({
        type: AUTO_FILL_ATTRIBUTES,
        payload: {
          attributes: extractedAttributes,
        },
      });
    }
  };

  const propagateChange = (value) => {
    const trimmedValue = value.trim();

    dispatch({
      type: HANDLE_CHANGE,
      payload: {
        input_key: key,
        value: trimmedValue,
      },
    });

    // Auto-remplir les attributs après le changement de titre
    autoFillAttributes(trimmedValue);
  };

  return (
    <>
      <div className='form-item-header'>
        <p className='h2'>Titre de votre annonce{required && <Asterisk />}</p>
        {helptext && <p className='subtext'>{helptext}</p>}
      </div>
      <div className='form-item-content'>
        <SpellCheckerInput
          defaultValue={titleValue}
          onChange={handleChange}
          placeholder=''
          // Tricks to get content via onBlur on the Div EditableContent of SpellCheckerInput
          onBlur={() => propagateChange(title)}
        />
        <p className='subtext'>Limite de caractères : {max_length}</p>
      </div>
    </>
  );
}

export default connect((state) => {
  const { form_fields, validation_rules } = state.products;
  const titleValue = form_fields[AD_DETAILS_API_IDS.TITLE_AND_DESCRIPTION.TITLE];
  const categories = form_fields[AD_DETAILS_API_IDS.CATEGORIES.CATEGORIE];
  const currentAttributes = form_fields[AD_DETAILS_API_IDS.ATTRIBUTES.MAIN_KEY] || {};

  return {
    titleValue,
    validation_rules,
    categories,
    currentAttributes,
  };
})(Title);
